import React, { useState } from 'react';
import './ManagePremium.css';

const ManagePremium = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [newPlan, setNewPlan] = useState('');
  const [users, setUsers] = useState([
    { id: 'U001', name: 'John Doe', plan: 'Basic', profile: 'Basic Plan - Access to limited features' },
    { id: 'U002', name: 'Jane Smith', plan: 'Standard', profile: 'Standard Plan - Access to standard features' },
    { id: 'U003', name: 'Sam Wilson', plan: 'Premium', profile: 'Premium Plan - Access to all features' },
  ]);

  const plans = ['Basic', 'Standard', 'Premium'];

  const handleUpdatePlanClick = (user) => {
    setCurrentUser(user);
    setShowModal(true);
  };

  const handlePlanChange = (plan) => {
    setNewPlan(plan);
  };

  const handleSavePlan = () => {
    if (currentUser && newPlan) {
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === currentUser.id ? { ...user, plan: newPlan } : user
        )
      );
      setShowModal(false);
      setNewPlan('');
    }
  };

  return (
    <div className="content-box animated">
      <h3>Manage Premium Plans</h3>
      <p>Below are the profiles of users subscribed to premium plans.</p>
      <div className="user-profiles">
        {users.map((user) => (
          <div key={user.id} className="user-profile-card">
            <h4>{user.name}</h4>
            <p><strong>User ID:</strong> {user.id}</p>
            <p><strong>Plan:</strong> {user.plan}</p>
            <p><strong>Profile:</strong> {user.profile}</p>
            <button
              className="update-plan-btn"
              onClick={() => handleUpdatePlanClick(user)}
            >
              Update Plan
            </button>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Update Plan for {currentUser?.name}</h3>
            <p>Select a new plan:</p>
            {plans.map((plan) => (
              <div key={plan}>
                <input
                  type="radio"
                  id={plan}
                  name="plan"
                  value={plan}
                  checked={newPlan === plan}
                  onChange={() => handlePlanChange(plan)}
                />
                <label htmlFor={plan}>{plan} Plan</label>
              </div>
            ))}
            <button className="modal-save-btn" onClick={handleSavePlan}>Save</button>
            <button className="modal-close-btn" onClick={() => setShowModal(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagePremium;
